/* eslint-disable*/
import _ from 'lodash';

const UNIT_CONVERSIONS = {
  g: 1,
  grams: 1,
  ounces: 28.3495,
  oz: 28.3495
}

// Added below functions for updating webapp foods

const isCustom = (unit) => {
  return (unit !== 'g' && unit !== 'grams' && unit !=='oz' && unit !=='ounces')
}

const handleDecimal = (val) => {
  if(val === 0) {
    return 0
  } else if(val % 1 === 0) {
    return Math.round(val)
  } else {
    return Math.round(val * 1000) / 1000
  }
}

const setBaseGrams = (baseUnit, baseGrams, baseSize) => {
  if (!isCustom(baseUnit) && baseGrams === 0) {
    return handleDecimal(UNIT_CONVERSIONS[baseUnit] * baseSize)
  } else if (baseGrams){
    return handleDecimal(baseGrams)
  } else {
    return 0
  }
}

const setBaseSize = (baseUnit, baseGrams, baseSize) => {
  if (!isCustom(baseUnit) && baseGrams === 0) {
    return 1
  } else {
    return handleDecimal(baseSize)
  }
}

export default class Item {
  constructor(data) {
    if(data.itemType === 'recipe') {
      this.foods = (data.foods) ? data.foods : []
    }

    this.category = (data.category) ? data.category : 'other'
    this.baseCalories = (data.baseCalories) ? Number(data.baseCalories) : 0
    this.baseCarbs = (data.baseCarbs) ? Number(data.baseCarbs) : 0
    this.baseFat = (data.baseFat) ? Number(data.baseFat) : 0
    this.baseFiber = (data.baseFiber) ? Number(data.baseFiber) : 0
    this.baseProtein = (data.baseProtein) ? Number(data.baseProtein) : 0
    this.baseUnit = (data.baseUnit) ? data.baseUnit : 'grams'
    this.baseGrams = setBaseGrams(this.baseUnit, (data.baseGrams) ? Number(data.baseGrams) : 0, (data.baseSize) ? Number(data.baseSize) : 1)
    this.baseSize = setBaseSize(this.baseUnit, (data.baseGrams) ? Number(data.baseGrams) : 0, (data.baseSize) ? Number(data.baseSize) : 1)
    this.baseServing = (data.baseServing) ? Number(data.baseServing) : 1
    this.dateCreated = (data.dateCreated) ? new Date(data.dateCreated).toISOString() : new Date().toISOString()
    this.dateAdded = data.dateAdded
    this.itemType = (data.itemType) ? data.itemType : 'food'
    this.name = (data.name) ? data.name : ''
    this.origin = (data.origin) ? data.origin : 'manual'
    this.serving = (data.serving || data.serving === 0) ? handleDecimal(Number(data.serving)) : handleDecimal(this.baseSize)
    this.unit = (data.unit) ? data.unit : this.baseUnit
    this.multiplier = (data.multiplier) ? data.multiplier : 1
    this.instructions = (data.instructions) ? data.instructions : ''
    this.thumbnailUrl = (data.thumbnailUrl) ? data.thumbnailUrl: ''
    this.bannerUrl = (data.bannerUrl) ? data.bannerUrl: ''
    this.customServing = (data.customServing) ? data.customServing : {
      servingWeightGrams: (this.baseGrams === 0) ? this.baseSize : this.baseGrams,
      unit: (isCustom(data.unit)) ? this.unit : 'servings'
    }
    this.id = data.id;
    this.sequenceNumber = data.sequenceNumber;
    this.favoriteId = data.favoriteId;
  }

  setAttribute(key, value) {
    this[key] = value
  }

  getAttribute(key) {
   return this[key]
  }

  getProtein() {
    let total = 0
    if(this.itemType === 'alcohol')
      return 0

    if(this.itemType === 'recipe') {
      if((_.isEmpty(this.foods)) !== true) {
        this.foods.forEach((food) => {
          if(food.baseGrams === 0 && food.baseSize === 0)
            return 0
          else if(food.baseGrams > 0 && UNIT_CONVERSIONS[food.unit])
            total += ((food.baseProtein / food.baseGrams) * UNIT_CONVERSIONS[food.unit] * food.serving)
          else
            total += food.baseProtein*(food.serving/food.baseSize)
        })
      }
      return total
    }

    if(this.baseGrams === 0 && this.baseSize === 0)
      return 0
    else if(this.unit === this.customServing.unit && this.baseGrams > 0 && this.baseSize > 0)
      return (this.baseProtein * ((this.serving / this.baseSize) * (this.customServing.servingWeightGrams / this.baseGrams)))
    else if(this.baseGrams > 0 && UNIT_CONVERSIONS[this.unit])
      return ((this.baseProtein / this.baseGrams) * UNIT_CONVERSIONS[this.unit] * this.serving)
    else
      return (this.baseProtein * (this.serving / this.baseSize))
  }

  getRecipeProtein() {
    let total = 0
    if((_.isEmpty(this.foods)) !== true) {
      this.foods.forEach((food) => {
        if(food.baseGrams === 0 && food.baseSize === 0)
          return 0
        else if(food.customServing && food.unit === food.customServing.unit && food.baseGrams > 0 && food.baseSize > 0)
          total += (food.baseProtein * ((food.serving / food.baseSize) * (food.customServing.servingWeightGrams / food.baseGrams)))
        else if(food.baseGrams > 0 && UNIT_CONVERSIONS[food.unit])
          total += ((food.baseProtein / food.baseGrams) * UNIT_CONVERSIONS[food.unit] * food.serving)
        else
          total += food.baseProtein*(food.serving/food.baseSize)
      })
    }
    if(total === 0)
      return 0
    else if(UNIT_CONVERSIONS[this.unit]) {
      return (total * (UNIT_CONVERSIONS[this.unit] * this.serving)  / this.baseGrams)    }
    else
      return (total / (this.baseServing / this.baseSize)) * this.serving
  }

  getSingleServingProtein() {
    let total = 0
    if(this.baseServing === 0 || this.baseSize === 0) {
      return 0
    } else if((_.isEmpty(this.foods)) !== true) {
      this.foods.forEach((food) => {
        if(food.baseGrams === 0 && food.baseSize === 0)
          return 0
        else if(food.customServing && food.unit === food.customServing.unit && food.baseGrams > 0 && food.baseSize > 0)
          total += (food.baseProtein * ((food.serving / food.baseSize) * (food.customServing.servingWeightGrams / food.baseGrams)))
        else if(food.baseGrams > 0 && UNIT_CONVERSIONS[food.unit])
          total += ((food.baseProtein / food.baseGrams) * UNIT_CONVERSIONS[food.unit] * food.serving)
        else
          total += food.baseProtein*(food.serving/food.baseSize)
      })
    }
    if(total === 0)
      return 0
    else if(UNIT_CONVERSIONS[this.unit]) {
      return ((total / this.baseSize) * UNIT_CONVERSIONS[this.unit] / this.serving)
    }
    else
      return (total / (this.baseServing / this.baseSize))
  }

  getRecipeCarbs() {
    let total = 0

    if((_.isEmpty(this.foods)) !== true) {
      this.foods.forEach((food) => {
        if(food.baseGrams === 0 && food.baseSize === 0)
          return 0
        else if(food.customServing && food.unit === food.customServing.unit && food.baseGrams > 0 && food.baseSize > 0)
          total += (food.baseCarbs * ((food.serving / food.baseSize) * (food.customServing.servingWeightGrams / food.baseGrams)))
        else if(food.baseGrams > 0 && UNIT_CONVERSIONS[food.unit])
          total += ((food.baseCarbs / food.baseGrams) * UNIT_CONVERSIONS[food.unit] * food.serving)
        else
          total += food.baseCarbs*(food.serving/food.baseSize)
      })
    }

    if(total === 0)
      return 0
    else if(UNIT_CONVERSIONS[this.unit]) {
      return (total * (UNIT_CONVERSIONS[this.unit] * this.serving)  / this.baseGrams)
    }
    else
      return (total / (this.baseServing / this.baseSize)) * this.serving

  }

  getSingleServingCarbs() {
    let total = 0

    if(this.baseServing === 0 || this.baseSize === 0) {
      return 0
    } else if((_.isEmpty(this.foods)) !== true) {
      this.foods.forEach((food) => {
        if(food.baseGrams === 0 && food.baseSize === 0)
          return 0
        else if(food.customServing && food.unit === food.customServing.unit && food.baseGrams > 0 && food.baseSize > 0)
          total += (food.baseCarbs * ((food.serving / food.baseSize) * (food.customServing.servingWeightGrams / food.baseGrams)))
        else if(food.baseGrams > 0 && UNIT_CONVERSIONS[food.unit])
          total += ((food.baseCarbs / food.baseGrams) * UNIT_CONVERSIONS[food.unit] * food.serving)
        else
          total += food.baseCarbs*(food.serving/food.baseSize)
      })
    }

    if(total === 0)
      return 0
    else if(UNIT_CONVERSIONS[this.unit]) {
      return ((total / this.baseSize) * UNIT_CONVERSIONS[this.unit] / this.serving)
    }
    else
      return (total / (this.baseServing/ this.baseSize))

  }

  getRecipeFat() {
    let total = 0

    if((_.isEmpty(this.foods)) !== true) {
      this.foods.forEach((food) => {
        if(food.baseGrams === 0 && food.baseSize === 0)
          return 0
        else if(food.customServing && food.unit === food.customServing.unit && food.baseGrams > 0 && food.baseSize > 0)
          total += (food.baseFat * ((food.serving / food.baseSize) * (food.customServing.servingWeightGrams / food.baseGrams)))
        else if(food.baseGrams > 0 && UNIT_CONVERSIONS[food.unit])
          total += ((food.baseFat / food.baseGrams) * UNIT_CONVERSIONS[food.unit] * food.serving)
        else
          total += food.baseFat*(food.serving/food.baseSize)
      })
    }

    if(total === 0)
      return 0
    else if(UNIT_CONVERSIONS[this.unit])
      return (total * (UNIT_CONVERSIONS[this.unit] * this.serving)  / this.baseGrams)
    else
      return (total / (this.baseServing / this.baseSize)) * this.serving

  }


  getSingleServingFat() {
    let total = 0

    if(this.baseServing === 0 || this.baseSize === 0) {
      return 0
    } else if((_.isEmpty(this.foods)) !== true) {
      this.foods.forEach((food) => {
        if(food.baseGrams === 0 && food.baseSize === 0)
          return 0
        else if(food.customServing && food.unit === food.customServing.unit && food.baseGrams > 0 && food.baseSize > 0)
          total += (food.baseFat * ((food.serving / food.baseSize) * (food.customServing.servingWeightGrams / food.baseGrams)))
        else if(food.baseGrams > 0 && UNIT_CONVERSIONS[food.unit])
          total += ((food.baseFat / food.baseGrams) * UNIT_CONVERSIONS[food.unit] * food.serving)
        else
          total += food.baseFat*(food.serving/food.baseSize)
      })
    }

    if(total === 0)
      return 0
    else if(UNIT_CONVERSIONS[this.unit]) {
      return ((total / this.baseSize) * UNIT_CONVERSIONS[this.unit] / this.serving)
    }
    else
      return (total / (this.baseServing / this.baseSize))

  }

  getCarbs() {
    let total = 0
    if(this.itemType === 'recipe') {
      if((_.isEmpty(this.foods)) !== true) {
        this.foods.forEach((food) => {
          if(food.baseGrams === 0 && food.baseSize === 0)
            return 0
          else if(food.baseGrams > 0 && UNIT_CONVERSIONS[food.unit])
            total += ((food.baseCarbs / food.baseGrams) * UNIT_CONVERSIONS[food.unit] * food.serving)
          else
            total += food.baseCarbs*(food.serving/food.baseSize)
        })
      }
      return total
    }

    if(this.itemType === 'alcohol') {
      const calories = this.getCalories()
      const sliderValue = Number(((this.baseFat * 9) / this.baseCalories).toFixed(2))
      const alcoholCarbs = ((calories * (1 - sliderValue)) / 4)
      return (alcoholCarbs >= 0) ? alcoholCarbs : 0
    } else if(this.baseGrams === 0 && this.baseSize === 0) {
      return 0
    } else if(this.unit === this.customServing.unit && this.baseGrams > 0 && this.baseSize > 0) {
      return (this.baseCarbs * ((this.serving / this.baseSize) * (this.customServing.servingWeightGrams / this.baseGrams)))
    } else if(this.baseGrams > 0 && UNIT_CONVERSIONS[this.unit]) {
      return ((this.baseCarbs / this.baseGrams) * UNIT_CONVERSIONS[this.unit] * this.serving)
    } else {
      return (this.baseCarbs * (this.serving / this.baseSize))
    }
  }

  getFat() {
    if(this.itemType === 'recipe') {
      let total = 0
      if((_.isEmpty(this.foods)) !== true) {
        this.foods.forEach((food) => {
          if(food.baseGrams === 0 && food.baseSize === 0)
            return 0
          else if(food.baseGrams > 0 && UNIT_CONVERSIONS[food.unit])
            total += ((food.baseFat / food.baseGrams) * UNIT_CONVERSIONS[food.unit] * food.serving)
          else
            total += food.baseFat*(food.serving/food.baseSize)
        })
      }
      return total
    }

    const calories = this.getCalories()
    const sliderValue = Number(((this.baseFat * 9) / this.baseCalories).toFixed(2))
    const alcoholFat = ((calories * Number(sliderValue)) / 9)
    if(this.itemType === 'alcohol')
      return (alcoholFat >= 0) ? alcoholFat : 0
    else if(this.baseGrams === 0 && this.baseSize === 0)
      return 0
    else if(this.unit === this.customServing.unit && this.baseGrams > 0 && this.baseSize > 0)
      return (this.baseFat * ((this.serving / this.baseSize) * (this.customServing.servingWeightGrams / this.baseGrams)))
    else if(this.baseGrams > 0 && UNIT_CONVERSIONS[this.unit])
      return ((this.baseFat / this.baseGrams) * UNIT_CONVERSIONS[this.unit] * this.serving)
    else
      return (this.baseFat * (this.serving / this.baseSize))
  }

  getRecipeFiber() {
    let total = 0
    if((_.isEmpty(this.foods)) !== true) {
      this.foods.forEach((food) => {
        if(food.baseGrams === 0 && food.baseSize === 0)
          return 0
        else if(food.customServing && food.unit === food.customServing.unit && food.baseGrams > 0 && food.baseSize > 0)
          total += (food.baseFiber * ((food.serving / food.baseSize) * (food.customServing.servingWeightGrams / food.baseGrams)))
        else if(food.baseGrams > 0 && UNIT_CONVERSIONS[food.unit])
          total += ((food.baseFiber / food.baseGrams) * UNIT_CONVERSIONS[food.unit] * food.serving)
        else
          total += food.baseFiber*(food.serving/food.baseSize)
      })
    }

    if(this.baseGrams > 0 && UNIT_CONVERSIONS[this.unit]) {
      return (((this.serving * UNIT_CONVERSIONS[this.unit]) / this.baseGrams) * total)
    } else {
      return (total / (this.baseServing / this.baseSize)) * this.serving
    }
  }

  getSingleServingFiber() {
    let total = 0
    if(this.baseServing === 0 || this.baseSize === 0) {
      return 0
    } else if((_.isEmpty(this.foods)) !== true) {
      this.foods.forEach((food) => {
        if(food.baseGrams === 0 && food.baseSize === 0)
          return 0
        else if(food.customServing && food.unit === food.customServing.unit && food.baseGrams > 0 && food.baseSize > 0)
          total += (food.baseFiber * ((food.serving / food.baseSize) * (food.customServing.servingWeightGrams / food.baseGrams)))
        else if(food.baseGrams > 0 && UNIT_CONVERSIONS[food.unit])
          total += ((food.baseFiber / food.baseGrams) * UNIT_CONVERSIONS[food.unit] * food.serving)
        else
          total += food.baseFiber*(food.serving/food.baseSize)
      })
    }

    if(this.baseGrams > 0 && UNIT_CONVERSIONS[this.unit]) {
      return ((total / this.baseSize) * UNIT_CONVERSIONS[this.unit] / this.serving)
    }
    else
      return (total / (this.baseServing / this.baseSize))
  }

  getFiber() {
    if(this.itemType === 'recipe') {
      let total = 0
      if((_.isEmpty(this.foods)) !== true) {
        this.foods.forEach((food) => {
          if(food.baseGrams === 0 && food.baseSize === 0)
            return 0
          else if(food.unit === food.customServing.unit && food.baseGrams > 0 && food.baseSize > 0)
            total += (food.baseFiber * ((food.serving / food.baseSize) * (food.customServing.servingWeightGrams / food.baseGrams)))
          else if(food.baseGrams > 0 && UNIT_CONVERSIONS[food.unit])
            total += ((food.baseFiber / food.baseGrams) * UNIT_CONVERSIONS[food.unit] * food.serving)
          else
            total += food.baseFiber*(food.serving/food.baseSize)
        })
      }
      return total
    }

    if(this.baseGrams === 0 && this.baseSize === 0)
      return 0
    else if(this.baseGrams > 0 && UNIT_CONVERSIONS[this.unit])
      return ((this.baseFiber / this.baseGrams) * UNIT_CONVERSIONS[this.unit] * this.serving)
    else
      return (this.baseFiber * (this.serving / this.baseSize))
  }

  getCalories() {
    if(this.itemType === 'recipe') {
      let total = 0
      if((_.isEmpty(this.foods)) !== true) {
        this.foods.forEach((food) => {
          total += food.baseCalories*(food.serving/food.baseSize)
        })
      }
      return total
    }

    if(this.baseGrams === 0 && this.baseSize === 0)
      return 0
    else if(this.unit === this.customServing.unit && this.baseGrams > 0 && this.baseSize > 0)
      return (this.baseCalories * ((this.serving / this.baseSize) * (this.customServing.servingWeightGrams / this.baseGrams)))
    else if(this.baseGrams > 0 && UNIT_CONVERSIONS[this.unit])
      return ((this.baseCalories / this.baseGrams) * UNIT_CONVERSIONS[this.unit] * this.serving)
    else
      return (this.baseCalories * (this.serving / this.baseSize))
  }

  getRecipeCalories() {
    let total = 0
    if((_.isEmpty(this.foods)) !== true) {
      this.foods.forEach((food) => {
        total += food.baseCalories*(food.serving/food.baseSize)
      })
    }

    if(this.baseGrams > 0 && UNIT_CONVERSIONS[this.unit])
      return ((total / this.baseGrams) * UNIT_CONVERSIONS[this.unit] * this.serving)
    else
      return (total / (this.baseServing / this.baseSize)) * this.serving
  }

  getSingleServingCalories() {
    let total = 0
    if(this.baseServing === 0 || this.baseSize === 0) {
      return 0
    } else if((_.isEmpty(this.foods)) !== true) {
      this.foods.forEach((food) => {
        total += food.baseCalories*(food.serving/food.baseSize)
      })
    }

    if(this.baseGrams > 0 && UNIT_CONVERSIONS[this.unit])
      return ((total / this.baseGrams) * UNIT_CONVERSIONS[this.unit] * this.serving)
    else
      return (total / (this.baseServing / this.baseSize))
  }

  toObject() {
      return {
        baseCalories: this.baseCalories,
        baseCarbs: this.baseCarbs,
        baseFat: this.baseFat,
        baseFiber: this.baseFiber,
        baseGrams: this.baseGrams,
        baseServing: this.baseServing,
        baseProtein: this.baseProtein,
        baseSize: this.baseSize,
        baseUnit: this.baseUnit,
        category: this.category,
        dateCreated: this.dateCreated,
        dateAdded: this.dateAdded,
        name: this.name,
        origin: this.origin,
        serving: this.serving,
        itemType: this.itemType,
        unit: this.unit,
        foods: this.foods,
        customServing: this.customServing,
        instructions: this.instructions,
        thumbnailUrl: this.thumbnailUrl,
        bannerUrl: this.bannerUrl,
        id: this.id,
        sequenceNumber: this.sequenceNumber,
        favoriteId: this.favoriteId
      }
  }
}
